import * as angular from 'angular';

angular.module('app.components', [])

// Components compartilhado
require('compartilhado/components/aba')
require('compartilhado/components/anexos')
require('compartilhado/components/arrastavel')
require('compartilhado/components/baixar-arquivo')
require('compartilhado/components/bto-alternar')
require('compartilhado/components/credencial-usuario')
require('compartilhado/components/img-usuario')
require('compartilhado/components/ler-arquivo')
require('compartilhado/components/painel')
require('compartilhado/components/tempo-decorrido')
require('compartilhado/components/visualizar-arquivo')
require('compartilhado/components/preview-image')
require('compartilhado/components/redirecionamentos')
require('compartilhado/components/segmento-selecionado')
require('compartilhado/components/listas/situacoes')
require('compartilhado/components/versao')
require('compartilhado/components/chat')



// WEBPACK FOOTER //
// ./src/components/index.js